import { FC, lazy, Suspense } from 'react'
import { Toaster } from 'react-hot-toast'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'
import { RequirePatientAuth } from 'src/auth/RequirePatientAuth'
import { PageLoading } from 'src/common/components'
// PATIENT LAYOUT
const PatientLayout = lazy(() => import('src/app/PatientLayout').then((module) => ({ default: module.PatientLayout })))
// PATIENT AUTH
const AuthLayout = lazy(() => import('src/auth/AuthLayout').then((module) => ({ default: module.AuthLayout })))
const LinkSent = lazy(() => import('src/auth/LinkSent').then((module) => ({ default: module.LinkSent })))
const ResendLink = lazy(() => import('src/auth/ResendLink').then((module) => ({ default: module.ResendLink })))
// SURVEYS
const SurveyViewer = lazy(() => import('src/surveys/SurveyViewer').then((module) => ({ default: module.SurveyViewer })))
const ActiveItems = lazy(() => import('src/dashboard/ActiveItems').then((module) => ({ default: module.ActiveItems })))

export const Router: FC = () => {
  return (
    <BrowserRouter>
      <Toaster position='top-center' />
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <Routes>
          <Route
            path='/'
            element={
              <RequirePatientAuth>
                <Suspense fallback={<PageLoading />}>
                  <PatientLayout />
                </Suspense>
              </RequirePatientAuth>
            }
          >
            <Route index element={<Navigate to='dashboard' replace />} />
            <Route
              path='dashboard'
              element={
                <Suspense fallback={<PageLoading />}>
                  <ActiveItems />
                </Suspense>
              }
            />
            <Route
              path='assessments/:assessmentId'
              element={
                <Suspense fallback={<PageLoading />}>
                  <SurveyViewer />
                </Suspense>
              }
            />
          </Route>
          <Route
            path='auth'
            element={
              <Suspense fallback={<PageLoading />}>
                <AuthLayout />
              </Suspense>
            }
          >
            <Route
              path='link/resend'
              element={
                <Suspense fallback={<PageLoading />}>
                  <ResendLink />
                </Suspense>
              }
            />
            <Route
              path='link/sent'
              element={
                <Suspense fallback={<PageLoading />}>
                  <LinkSent />
                </Suspense>
              }
            />
            <Route index element={<Navigate to='link/resend' replace />} />
          </Route>
          <Route path='*' element={<Navigate to='dashboard' replace />} />
        </Routes>
      </QueryParamProvider>
    </BrowserRouter>
  )
}
